// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "acm-carol-ferrera.firebaseapp.com",
  "projectId": "acm-carol-ferrera",
  "storageBucket": "acm-carol-ferrera.appspot.com",
  "messagingSenderId": "302104817401",
  "appId": "1:302104817401:web:cb8780ba417c9c35b93c28",
  "measurementId": "G-2XD4SGQKRP",
  "apiKey": "AIzaSyDeZOLXFo4q-KiwSLkNTogLILgr5aNUomM"
};
